// extracted by mini-css-extract-plugin
export default {"topParticipantsList":"leaderboards_topParticipantsList__oRA-n","topTeamsList":"leaderboards_topTeamsList__Cx8HO","action":"leaderboards_action__Nmr6j"};